import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ProgramSecureUploadPage } from './program-secure-upload';

@NgModule({
  declarations: [
    ProgramSecureUploadPage,
  ],
  imports: [
    IonicPageModule.forChild(ProgramSecureUploadPage),
  ],
})
export class ProgramSecureUploadPageModule {}



// WEBPACK FOOTER //
// ./src/pages/program-secure-upload/program-secure-upload.module.ts